// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerRevenue_Page__3gMp8","FilterInput":"ManagerRevenue_FilterInput__2jO0k"};